import { Alert, Box, Button, Checkbox, Dialog, FormControl, Grid, IconButton, InputLabel, LinearProgress, MenuItem, Select, Snackbar, styled, Tooltip, Typography } from '@mui/material';
import { SiTrackGrid } from '../../components/si-track-grid/si-track-grid';
import { FormAutoCompleteMultiSelectDynamic } from '../../components/hook-form/form-autocomplete-multi-select.dynamic.component';
import { usersApiKeyStore } from '../../api/users-api-key-store';
import { marketAreaApiKeyStore } from '../../api/masters/market-area-api-key-store';
import { inspectorsColumns } from './inspectors-grid-columns';
import { skillSetApiKeyStore } from '../../api/masters/skill-set-api-key-store';
import { equipmentApiKeyStore } from '../../api/masters/equipment-api-key-store';
import { useFormContext } from 'react-hook-form';
import { useEffect, useMemo, useState } from 'react';
import { useSaveData } from '../../hooks/useSaveData';
import { UserPermissionName } from '../../models/user-permission-name';
import { Icons } from '../../assets/icons';
import BulkScheduleCalenderComponent from './bulk-schedule-calender.component';
import { WorkOrder } from '../../models/workOrder';
import React from 'react';
import { GridCellProps, GridRowProps } from '@progress/kendo-react-grid';
import { DialogActionsBar } from '@progress/kendo-react-dialogs';
import { useLoadData } from '../../hooks/useLoadData';
import { ApiResponse } from '../../models/api-response';
import { GridColumnConfig, GridPreference } from '../../models/gridCoumnConfig';
import { gridApiKeyStore } from '../../api/grid-api-key-store';
import { State } from '@progress/kendo-data-query';
import useDebounce from '../../hooks/use-debounce';
import { useSnackbar } from '../../hooks/use-snackbar.hook';
import { useAuthorize } from '../../hooks/use-authorize';
import { FormCheckbox } from '../../components/hook-form/form-checkbox.component';
import { LoadingIndicator } from '../../components/loading-indicator.component';

const styling = {
  root: { paddingBottom: '10px' },
  buttonStyle: { Padding: '15px' },
};

interface CustomGridCellProps {
  field: string;
}
interface CellProps {
  inspector: any;
}

interface ISelectInspector {
  selectedWorkorder: WorkOrder[];
  handleSelectedInspectors: (value: WorkOrder[]) => void;
  selectedInspector: any[];
  isRecall: boolean;
  commonInspector: any;
  handleResetRecall: () => void;
}

export const SelectInspector = ({
  selectedWorkorder,
  handleSelectedInspectors,
  selectedInspector,
  isRecall,
  commonInspector,
  handleResetRecall,
}: ISelectInspector) => {
  const { showSnackbar } = useSnackbar();
  const { setValue, getValues } = useFormContext();
  const [inspectorID, setInspectorID] = useState<any>();
  const [calendarDialog, setCalendarDialog] = useState<any>();
  const [equipmentIDs, setEquipmentIDs] = useState<any>();
  const [skillsetIDs, setSkillsetIDs] = useState<any>();
  const [marketAreaIDs, setMarketAreaIDs] = useState<any>();
  const [userIDs, setUserIDs] = useState<any>();
  const [isOpenSnackbar, setIsOpenSnackbar] = useState(false);
  const [message, setMessage] = useState<string>();
  const [selectInspectorName, setSelectInspectorName] = useState<string>("");
  const [openConfirmDialog, setConfirmDialog] = useState<boolean>(false);
  const [oldSingleSelectInspector, setOldSingleSelectedIns] = useState<any>();
  const [singleSelectInspector, setSingleSelectedIns] = useState<any>();

  const [selectedInspectorID, setSelectedInspectorID] = useState<any>();
  const [onReportCheckbox, setReportCheckbox] = useState<boolean>(getValues('remoteInspection') ?? false);

  const { isLoading: isSecondaryInsLoading, isFetching: isSecondaryInsFetching, data: secondaryData } = useLoadData<ApiResponse<any>>(
    usersApiKeyStore.getUserSecondayInspectors(),
    !!onReportCheckbox
  );

  const { isLoading, data, mutateAsync } = useSaveData<any>(usersApiKeyStore.updateInspectors());

  const updatedInspectorsColumns = useMemo<GridColumnConfig[]>(() => {
    if (!onReportCheckbox) {
      return inspectorsColumns;
    }

    return [
      ...inspectorsColumns,
      {
        title: 'Seconday Inspector',
        field: 'isSecondaryInspector',
        filter: 'text',
        searchable: false,
        isGroupable: false,
        isHideColumnMenu: true
      },
    ];
  }, [onReportCheckbox]);

  const updateSelecteData = (value: any) => {
    if (value) {
      const updatedData = updatedInspectorData?.map((d: any) => ({
        ...d,
        isSelected: value?.userID === d.userID,
      }));
      setUpdatedInspectorData(updatedData);
    }
    else {
      const updatedData = updatedInspectorData?.map((d: any) => ({
        ...d,
        isSelected: false,
      }));
      setUpdatedInspectorData(updatedData);
    }
  }

  // -------------------------------------
  const [updatedInspectorData, setUpdatedInspectorData] = useState<any[]>([]);
  useEffect(() => {
    if (isRecall) {
      setUpdatedInspectorData([]);
      handleFilterClick();
      handleSelectedInspector([]);
      setSelectInspectorName("");
    }
  }, [isRecall]);


  //const calculateMatchPercentage = (selectedSkills: string[], inspectorSkills: string[]): number => {
  //    const matchingSkills = inspectorSkills?.filter((skill) => selectedSkills?.includes(skill));

  //    if (matchingSkills?.length && selectedSkills?.length) {
  //        return (matchingSkills?.length / selectedSkills?.length) * 100;
  //    }
  //    return 0;
  //};
  const calculateMatchPercentage = (
    workOrderSkills: string[],
    inspectorSkills: string[]
  ): number => {

    const cleanedWorkOrderSkills = (workOrderSkills || []).filter(
      (id) => id !== "" && id !== null && id !== undefined
    );

    // If work order has no skills → 100%
    if (cleanedWorkOrderSkills.length === 0) {
      return 100;
    }

    const matchingSkills = cleanedWorkOrderSkills.filter(skill =>
      (inspectorSkills || []).includes(skill)
    );

    const percentage =
      (matchingSkills.length / cleanedWorkOrderSkills.length) * 100;

    return Number(percentage.toFixed(2)); // 33.33
  };

  const setInspectorData = (inspectorData: any) => {
    // Collect unique skill IDs from selectedWorkorder
    const selectedWorkorderSkills = Array.from(
      new Set(
        selectedWorkorder
          ?.flatMap((workorder: any) => workorder?.serviceSkillSetIDList?.split(','))
          ?.map((skill) => skill?.trim())
      )
    );

    const selectedWorkorderEquipments = Array.from(
      new Set(
        selectedWorkorder
          ?.flatMap((workorder: any) => workorder?.serviceEquipmentIDList?.split(','))
          ?.map((skill) => skill?.trim())
      )
    );

    // Calculate match percentage for each inspector
    const recalculatedInspectorData = inspectorData?.map((inspector: any) => {
      return {
        ...inspector,
        // selected: selectedInspector?.some((s) => s.userID === inspector.userID),
        isSelected: selectedInspector?.length > 0 ?
          selectedInspector?.some((s) => s.userID === inspector.userID) :
          commonInspector?.isInspectorAssignedOnReady == true && inspector.userName === commonInspector?.inspectorName
        ,
        matchPercentageSkill: calculateMatchPercentage(
          selectedWorkorderSkills,
          inspector.userSkillSetIDList?.split(',')?.map((skill: any) => skill?.trim())
          // inspector?.userID
        ),
        matchPercentageEquipment: calculateMatchPercentage(
          selectedWorkorderEquipments,
          inspector.userEquipmentIDList?.split(',')?.map((equip: any) => equip?.trim())
        ),
      };
    });

    if (selectedInspector?.length == 0 && commonInspector?.isInspectorAssignedOnReady == true && recalculatedInspectorData?.length > 0) {
      const selectedInspectors = recalculatedInspectorData?.filter((user: any) => user.isSelected);
      checkSelectionValidation(selectedInspectors ?? []);
    }

    // Update inspector data with recalculated match percentages
    setUpdatedInspectorData(recalculatedInspectorData);
  }

  const getValidWorkOrders = (workOrders: any[]) => {
    return workOrders?.filter(
      wo =>
        wo?.serviceSkillsets &&
        wo?.serviceSkillsets?.trim() !== "" &&
        wo?.serviceSkillsets?.trim() !== "-N/A-" &&
        wo?.serviceSkillsets?.trim() !== "None Required"
    );
  };

  const getFilteredInspectors = (inspectors: any[], workOrders: any[]) => {
    if (!workOrders || workOrders?.length === 0) {
      return inspectors;
    }

    const validWorkOrders = getValidWorkOrders(workOrders);

    if (validWorkOrders?.length === 0) {
      return inspectors;
    }

    return inspectors?.filter(inspector =>
      areAnySkillsetsMatched(validWorkOrders, inspector)
    );
  };

  useEffect(() => {
    if (data?.data) {
      const filteredInspectors = getFilteredInspectors(data?.data, selectedWorkorder);
      setInspectorData(filteredInspectors);
    }
    setValue('inspectorID', 0);
  }, [selectedWorkorder, data]);

  // ----------------------------

  //=======================

  const handleOnReportInspection = (event: any) => {
    const isReportChecked = event?.target?.checked;
    setReportCheckbox(isReportChecked);
    if (!isReportChecked) {
      setValue('secondaryInspectorID', null);
      setUpdatedInspectorData(prevData =>
        prevData?.map(inspector => ({
          ...inspector,
          secondaryInspector: null,
        }))
      );
    }
  }

  const handleSecondaryInspectorChange = (event: any, userID: any) => {
    const selectedSecondaryInspector = event.target.value;
    setValue('secondaryInspectorID', selectedSecondaryInspector);
    setUpdatedInspectorData(prevData =>
      prevData?.map(inspector =>
        inspector.userID === userID
          ? { ...inspector, secondaryInspector: selectedSecondaryInspector }
          : inspector
      )
    );
  }

  const SecondaryInspectorCell = ({ inspector }: CellProps) => {
    const inspectorValue = inspector?.secondaryInspector;

    return (
      <td>
        {inspector?.isSelected && (
          <>
            <LoadingIndicator isLoading={isSecondaryInsLoading || isSecondaryInsFetching} />
            <FormControl fullWidth>
              <InputLabel size="small" id="demo-simple-select-label">Select Secondary Inspector</InputLabel>
              <Select
                size="small"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={inspectorValue}
                label="Select Secondary Inspector"
                onChange={(event) => handleSecondaryInspectorChange(event, inspector?.userID)}
              >
                {secondaryData?.data
                  ?.filter((item: any) => item.userID !== selectedInspectorID)
                  .map((item: any) => (
                    <MenuItem key={item.userID} value={item.userID}>
                      {item.userName}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </>
        )}
      </td>
    );
  };

  //=========================

  const checkSelectionValidation = (values: any[]) => {
    const singleInspector: any = values[0];
    if (values?.length > 0 && commonInspector?.isInspectorAssignedOnReady &&
      selectInspectorName != "" &&
      commonInspector?.inspectorName == selectInspectorName &&
      selectInspectorName != singleInspector?.userName
    ) {
      setConfirmDialog(true);
      setSingleSelectedIns(values);
      return;
    }
    else {
      handleSelectedInspector(values)
    }
    setSelectInspectorName(singleInspector?.userName);
  }

  const handleSelectedInspector = (values: any[]) => {
    if (values && values.length > 0) {
      const hasCompactionTest = selectedWorkorder?.some(order => order?.serviceName === "Compaction Test");
      if (values[0]?.hasDuplicateEquipments && hasCompactionTest) {
        setIsOpenSnackbar(true);
        setMessage(values[0]?.equipmentDuplicateWarningMsg)
        setValue('inspectorID', 0);
        updateSelecteData(null)
        handleSelectedInspectors([]);
        setSelectedInspectorID(0);
        return
      }
      else {
        setValue('inspectorID', values[0].userID);
        updateSelecteData(values[0]);
        setSelectedInspectorID(values[0].userID);
      }
    } else {
      setValue('inspectorID', 0);
      updateSelecteData(null)
    }
    setValue('secondaryInspectorID', null);
    setOldSingleSelectedIns(values);
    handleSelectedInspectors(values);
    setUpdatedInspectorData(prevData =>
      prevData?.map(inspector => ({
        ...inspector,
        isSelected: inspector?.userID === values[0]?.userID,
        secondaryInspector: null,
      }))
    );
  };


  const handleFilterClick = () => {
    handleResetRecall();
    handleSelectedInspectors([]);
    setSelectInspectorName('');
    mutateAsync({
      data: {
        skillsets: skillsetIDs?.map((p: any) => p.skillsetID),
        equipments: equipmentIDs?.map((p: any) => p.equipmentID),
        marketAreas: marketAreaIDs?.map((p: any) => p.marketAreaID),
        inspectors: userIDs?.map((p: any) => p.userID),
        // workOrders: selectedWorkorder?.map((w: any) => w.workOrderID),
      },
    });
  };

  const handleInspectorCalendar = (inspectorID: any) => {
    setInspectorID(inspectorID);
    setCalendarDialog(true);
  };

  const InspectorCustomGridCell = ({ field }: CustomGridCellProps) => {
    if (field === 'isSecondaryInspector') {
      return (dataItem: any) => {
        return <SecondaryInspectorCell inspector={dataItem.dataItem} />;
      };
    }
    if (field === 'calendar') {
      return (dataItem: any) => (
        <td>
          <IconButton aria-label="move" onClick={() => handleInspectorCalendar(dataItem?.dataItem?.userID)}>
            <Tooltip title={<Typography variant="body1">Calendar</Typography>}>
              <img src={Icons.IconCalendar} alt="Schedule" />
            </Tooltip>
          </IconButton>
        </td>
      );
    }
    // else if (field === 'userEquipments') {
    //   return (dataItem: any) => {
    //     const progress = dataItem?.dataItem?.matchPercentageEquipment || 0;

    //     const getColor = (value: number) => {
    //       if (value >= 100) return 'green';
    //       if (value >= 50 && value < 80) return 'yellow';
    //       if (value >= 30 && value < 50) return 'orange';
    //       return 'red-progress';
    //     };

    //     const progressColor = getColor(progress);
    //     return (
    //       <td>
    //         {selectedWorkorder?.length > 0 ? (
    //           <>
    //             <p style={{ paddingBottom: 3 }}>{dataItem?.dataItem?.userEquipments || ''}</p>
    //             <Box display="flex" alignItems="center" flexDirection="column" gap={1}>
    //               <Box
    //                 sx={{
    //                   width: '100%',
    //                   height: 10,
    //                   backgroundColor: '#e0e0e0',
    //                   borderRadius: 5,
    //                   overflow: 'hidden',
    //                   position: 'relative',
    //                 }}
    //               >
    //                 <LinearProgress
    //                   variant="determinate"
    //                   value={progress}
    //                   sx={{
    //                     height: '100%',
    //                     backgroundColor: 'transparent',
    //                     '& .MuiLinearProgress-bar': {
    //                       backgroundColor: progressColor,
    //                     },
    //                   }}
    //                 />
    //               </Box>
    //               <Typography
    //                 variant="body2"
    //                 sx={{
    //                   fontWeight: 'bold',
    //                 }}
    //               >
    //                 {progress?.toFixed(2)}%
    //               </Typography>
    //             </Box>
    //           </>
    //         ) : (
    //           dataItem?.dataItem?.userEquipments || ''
    //         )}
    //       </td>
    //     );
    //   };
    // }
    // else if (field === 'userSkillsets') {
    //   return (dataItem: any) => {
    //     const progress = dataItem?.dataItem?.matchPercentageSkill || 0;

    //     // Determine the color based on the progress value
    //     const getColor = (value: number) => {
    //       if (value >= 100) return 'green';
    //       if (value >= 50 && value < 80) return 'yellow';
    //       if (value >= 30 && value < 50) return 'orange';
    //       return 'red';
    //     };

    //     const progressColor = getColor(progress);
    //     return (
    //       <td>
    //         {selectedWorkorder?.length > 0 ? (
    //           <>
    //             <p style={{ paddingBottom: 3 }}>{dataItem?.dataItem?.userSkillsets || ''}</p>
    //             <Box display="flex" alignItems="center" flexDirection="column" gap={1}>
    //               <Box
    //                 sx={{
    //                   width: '100%',
    //                   height: 10,
    //                   backgroundColor: '#e0e0e0',
    //                   borderRadius: 5,
    //                   overflow: 'hidden',
    //                   position: 'relative',
    //                 }}
    //               >
    //                 <LinearProgress
    //                   variant="determinate"
    //                   value={progress}
    //                   sx={{
    //                     height: '100%',
    //                     backgroundColor: 'transparent',
    //                     '& .MuiLinearProgress-bar': {
    //                       backgroundColor: progressColor,
    //                     },
    //                   }}
    //                 />
    //               </Box>
    //               <Typography
    //                 variant="body2"
    //                 sx={{
    //                   fontWeight: 'bold',
    //                 }}
    //               >
    //                 {progress?.toFixed(2)}%
    //               </Typography>
    //             </Box>
    //           </>
    //         ) : (
    //           dataItem?.dataItem?.userSkillsets || ''
    //         )}
    //       </td>
    //     );
    //   };
    // }
  };

  const areAnySkillsetsMatched = (workOrderData: any, inspectorData: any) => {
    const inspectorSkills = inspectorData?.userSkillsets
      ?.split(',')
      ?.map((skill: any) => skill?.trim());

    return workOrderData?.every((workOrder: any) => {
      const serviceSkills = workOrder?.serviceSkillsets
        ?.split(',')
        ?.map((skill: any) => skill?.trim());

      return serviceSkills?.some((skill: any) => inspectorSkills?.includes(skill));
    });
  };

  const conditionalCellRender = (
    defaultRendering: React.ReactElement<HTMLTableCellElement> | null,
    props: GridCellProps
  ) => {
    const validWorkOrders = getValidWorkOrders(selectedWorkorder);

    const result = !areAnySkillsetsMatched(validWorkOrders, props?.dataItem);
    if (
      props.field === 'isSelected' &&
      selectedWorkorder?.length > 0 && result
      // &&(props?.dataItem?.matchPercentageSkill === 0)
    ) {

      return (
        <Tooltip title={<Typography variant="body1">
          {/* Inspector does not meet inspection criteria */}
          The Primary Inspector does not have any matching skill set(s) for the selected inspection.</Typography>}>
          <td>
            <Checkbox
              disabled={result}
            // disabled={
            //   props?.dataItem?.matchPercentageSkill == 0 
            // }
            />
          </td>
        </Tooltip>
      );
    } else {
      return defaultRendering;
    }
  };

  // const rowRender = (row: React.ReactElement, rowProps: GridRowProps) => {
  //   const isMatched =
  //     rowProps.dataItem?.matchPercentageSkill === 100 && rowProps.dataItem?.matchPercentageEquipment === 100;
  //   const backgroundColor = isMatched ? '#5ae385' : 'rgb(255 255 255)'; // Green for 100%, Red otherwise
  //   const trElement = React.cloneElement(row, {
  //     style: { backgroundColor: backgroundColor },
  //   });
  //   return trElement;
  // };

  // -------------------------------------------------Grid Layout------------------------------

  const {
    isLoading: isLoadingGridLayout,
    data: gridLayouts,
    refetch: refetchGridLayout
  } = useLoadData<ApiResponse<GridPreference>>(
    gridApiKeyStore.getGridLayout('BulkScheduleInspector', 'BulkScheduleInspector')
  );

  const { mutateAsync: mutateInspectorAsync } = useSaveData<any>(gridApiKeyStore.saveGridLayOut());
  const [gridConfig, setGridConfig] = useState<{
    dataState: State | undefined;
    columns: any[] | undefined;
  }>();

  const [filteredInspectors, setFilteredInspectors] = useState<any[]>([]);

  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  useEffect(() => {
    const filteredInspectorList = updatedInspectorData?.filter((Inspector) =>
      Object.values(Inspector).some(
        (value) => value && value.toString().toLowerCase().includes(debouncedSearchTerm.toLowerCase())
      )
    );
    setFilteredInspectors(filteredInspectorList || []);
  }, [debouncedSearchTerm, updatedInspectorData]);

  const handleInputChange = (value: string) => {
    setSearchTerm(value);
  };

  const handleSaveLayout = (gridDataState: State, gridColumns: GridColumnConfig[]) => {
    const data = {
      filterJSON: JSON.stringify(gridDataState),
      columnJSON: JSON.stringify(gridColumns),
      gridName: 'BulkScheduleInspector',
      pageName: 'BulkScheduleInspector',
    };

    mutateInspectorAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  const handleResetLayout = () => {
    const data = {
      filterJSON: null,
      columnJSON: null,
      gridName: 'BulkScheduleInspector',
      pageName: 'BulkScheduleInspector',
    };

    mutateInspectorAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  useEffect(() => {
    if (!gridLayouts?.data) return;

    try {
      const filterData = gridLayouts.data.filterJSON ? JSON.parse(gridLayouts.data.filterJSON) : null;

      const columnJson = gridLayouts.data.columnJSON ? JSON.parse(gridLayouts.data.columnJSON) : null;

      // if (filterData && columnJson) {
      setGridConfig({
        columns: columnJson,
        dataState: filterData,
      });
      // }
    } catch (error) {
      console.log('Error parsing grid layout JSON:', error);
    }
  }, [gridLayouts?.data]);

  // ----------------------------------------------------------------------------------------

  const handleSumbitConfirm = () => {
    setSelectInspectorName(singleSelectInspector[0].userName);
    handleSelectedInspector(singleSelectInspector);
    setConfirmDialog(false);

  }

  const handleClosedDialog = () => {
    handleSelectedInspector(oldSingleSelectInspector);
    setConfirmDialog(false);
  }

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  const scheduleWorkOrderGridColumns = useMemo(() => {
    if (gridConfig?.columns) {
      return gridConfig.columns
    }
    return updatedInspectorsColumns?.filter((column) => column?.field !== 'matchPercentage')?.filter((column) => column?.field !== 'matchPercentage')
  }, [gridConfig, updatedInspectorsColumns])

  return (
    <>
      <Grid container spacing={1}>
        <Grid item lg={2.5} sm={6} xl={2.5} xs={6}>
          <FormAutoCompleteMultiSelectDynamic
            name="instepectorFilter.userIDs"
            label="Inspectors"
            getQueryKeyConfig={() => usersApiKeyStore.getUsersByRole('ins')}
            optionsLabelKey="fullName"
            optionsValueKey="userID"
            onChange={(values: any) => setUserIDs(values)}
          />
        </Grid>
        <Grid item lg={3} sm={6} xl={3} xs={6}>
          <FormAutoCompleteMultiSelectDynamic
            name="instepectorFilter.marketAreaIDs"
            label="Market Areas"
            getQueryKeyConfig={() => marketAreaApiKeyStore.getMarketAreas()}
            optionsLabelKey="marketAreaName"
            optionsValueKey="marketAreaID"
            onChange={(values: any) => setMarketAreaIDs(values)}
          />
        </Grid>
        <Grid item lg={2.5} sm={6} xl={2.5} xs={6}>
          <FormAutoCompleteMultiSelectDynamic
            name="instepectorFilter.skillsetIDs"
            label="Skills"
            getQueryKeyConfig={() => skillSetApiKeyStore.getSkillSets()}
            optionsLabelKey="skillsetName"
            optionsValueKey="skillsetID"
            onChange={(values: any) => setSkillsetIDs(values)}
          />
        </Grid>
        <Grid item lg={2.5} sm={6} xl={2.5} xs={6}>
          <FormAutoCompleteMultiSelectDynamic
            name="instepectorFilter.equipmentIDs"
            label="Equipments"
            getQueryKeyConfig={() => equipmentApiKeyStore.getEquipments()}
            optionsLabelKey="equipmentName"
            optionsValueKey="equipmentID"
            onChange={(values: any) => setEquipmentIDs(values)}
          />
        </Grid>

        <Grid item lg={1.5} sm={6} xl={1.5} xs={6}>
          <Button type="button" onClick={handleFilterClick} title="Filter" className="btn btn-primary btn-Filter">
            Filter
          </Button>
        </Grid>
        <Grid item xl={12} lg={12} sm={12} xs={12}>
          <Grid
            container
            direction="row"
            sx={{
              justifyContent: "flex-end",
              alignItems: "flex-start",
            }}>
            <FormCheckbox label="Remote Inspection" name="remoteInspection" onChange={handleOnReportInspection} />
          </Grid>
        </Grid>
        <Grid item lg={12} sm={12} xl={12} xs={12} style={{ padding: '8px', paddingRight: '0' }}>
          <div style={{ padding: '16px', background: '#fff', borderRadius: '8px' }}>
            <SiTrackGrid
              fileTitle='schedule_inspector'
              columns={
                scheduleWorkOrderGridColumns
                // selectedWorkorder?.length > 0
                //   ? updatedInspectorsColumns
                //   : updatedInspectorsColumns?.filter((column) => column?.field !== 'matchPercentage')
              }
              dataItemKey="userID"
              selectedField="isSelected"
              preventCheckAndUnCheckOnHeaderelectionChange={['userID']}
              selectionMode="single"
              // selectionMode={data?.data?.length > 1 ? 'single' : 'multi'}
              conditionalCellRender={conditionalCellRender}
              customCell={(field) =>
                InspectorCustomGridCell({
                  field,
                })
              }
              onSelectedItems={checkSelectionValidation}
              // dataItems={data?.data}
              actionPermissions={{
                export: UserPermissionName.DOWNLOAD_GRID,
              }}
              isBusy={isLoading || isLoadingGridLayout}
              // rowRender={rowRender}

              // -----------------Grid Layout-------
              dataItems={filteredInspectors || []}
              reorderable
              handleSearch={handleInputChange}
              handleSaveLayout={handleSaveLayout}
              isSaveLayout={true}
              gridConfigFromApi={gridConfig}
              handleResetLayout={handleResetLayout}
            // -----------------Grid Layout-------
            />
          </div>
        </Grid>
      </Grid>
      {calendarDialog && (
        <BulkScheduleCalenderComponent
          open={calendarDialog}
          inspectorID={inspectorID}
          onClosed={() => setCalendarDialog(false)}
        />
      )}
      <Snackbar
        open={isOpenSnackbar}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        onClose={() => setIsOpenSnackbar(false)}
      >
        <Alert severity="error" variant="filled" sx={{ width: '100%' }} onClose={() => setIsOpenSnackbar(false)}>
          {message}
        </Alert>
      </Snackbar>

      {openConfirmDialog && (
        <Dialog
          open={openConfirmDialog}
          className="modalpopup"
          title={'CONFIRM STATUS'}
        // onClose={closeDialog}
        >
          <div>
            <div style={{ padding: '25px 50px' }}>
              <p>An inspector is already pre-selected. Do you want to replace the inspector?</p>
            </div>
          </div>
          <DialogActionsBar>
            <div className=" spaceBetween">
              <button
                style={{ cursor: 'pointer' }}
                className="btn btn-sm btn-default btn-lightGrey"
                onClick={handleClosedDialog}
                autoFocus
              >
                Cancel
              </button>
              <button
                className="btn btn-sm btn-primary  btn-delete"
                style={{
                  backgroundColor: isReadOnlyPermission ? '#d7dbdd' : '#0000b5',
                  color: isReadOnlyPermission ? 'black' : '#fff',
                  cursor: 'pointer'
                }}
                type="button"
                onClick={handleSumbitConfirm}
                disabled={isReadOnlyPermission}
              >
                Confirm
              </button>
            </div>
          </DialogActionsBar>
        </Dialog>
      )}
    </>
  );
};
